<div #trigger="cdkOverlayOrigin" (click)="toggleDropdown()" [class.is-open]="isOpen"
     cdkOverlayOrigin class="select-wrapper">
  <div [class.placeholder]="multiple ? !selectedOptions.length : !selectedValue" class="selected-text">
    <ng-container
      *ngTemplateOutlet="labelTemplate || defaultLabel; context: { $implicit: multiple ? selectedOptions : selectedOption, placeholder: placeholder, multiple: multiple }"></ng-container>
    <ng-template #defaultLabel>
      <div class="selected-container truncate">
        {{ selectedLabel }}
      </div>
    </ng-template>
  </div>
  <div [class.rotated]="isOpen" class="arrow-icon" [class.opacity-40]="disabled">
    <img alt="select" class="{{arrowClass}} h-4" src="/assets/icons/feather/chevron-down.svg">
  </div>
</div>

<ng-template
  (backdropClick)="isOpen = false"
  (detach)="isOpen = false"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayPositions]="[
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 4 },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: -4 }
  ]"
  backdropClass="cdk-overlay-transparent-backdrop"
  cdkConnectedOverlay
>
  <div class="dropdown-panel select-overlay-panel">
    @if (searchable) {
      <div (click)="$event.stopPropagation()" class="search-container">
        <input
          [(ngModel)]="searchText"
          autofocus
          class="search-input"
          placeholder="Buscar..."
          type="text">
        <img alt="search" class="h-4 filter-neutral-600" src="/assets/icons/feather/search.svg">
      </div>
    }

    <!-- Lista de opciones -->
    <ul class="options-list">
      @for (option of filteredOptions; track option.value) {
        <li (click)="selectOption(option); $event.stopPropagation()"
            [class.active]="isSelected(option)"
            [class.multiple]="multiple"
            [class.has-template]="!!optionTemplate"
            class="option-item">
          <ng-container
            *ngTemplateOutlet="optionTemplate || defaultOption; context: { $implicit: option, active: option.value === selectedValue }"></ng-container>
          <ng-template #defaultOption>{{ option.label }}</ng-template>
        </li>
      } @empty {
        <li class="option-item empty">Sin resultados</li>
      }
    </ul>

    <!-- Footer Template -->
    @if (footerTemplate) {
      <div (click)="$event.stopPropagation()" class="dropdown-footer">
        <ng-container [ngTemplateOutlet]="footerTemplate"></ng-container>
      </div>
    }
  </div>
</ng-template>
